import type { Dispatch } from 'redux';
import type { Prize } from '@/services/api/types';
import type { UserState, UserAction } from '@/redux/user/types';

export enum Actions {
  SetUserData = 'SetUserData',
  SetUserDataFail = 'SetUserDataFail',

  SetPrizeData = 'SetPrizeData',
  SetPrizeDataFail = 'SetPrizeDataFail',

  SetPointsData = 'SetPointsData',
  SetPointsDataFail = 'SetPointsDataFail',

  SetCountryData = 'SetCountryData',
  SetCountryDataFail = 'SetCountryDataFail',

  SetLanguageData = 'SetLanguageData',
  SetLanguageDataFail = 'SetLanguageDataFail',

  SetParticipantId = 'SetParticipantId',
  SetParticipantIdFail = 'SetParticipantIdFail'
}

export const setUserData =
  (data: UserState) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetUserData, data });
    } catch (error) {
      dispatch({ type: Actions.SetUserDataFail, error });
    }
  };

export const setUserPrize =
  (prize: Prize) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetPrizeData, prize });
    } catch (error) {
      dispatch({ type: Actions.SetPrizeDataFail, error });
    }
  };

export const setUserPoints =
  (points: number) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetPointsData, points });
    } catch (error) {
      dispatch({ type: Actions.SetPointsDataFail, error });
    }
  };

export const setUserCountry =
  (country: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetCountryData, country });
    } catch (error) {
      dispatch({ type: Actions.SetCountryDataFail, error });
    }
  };

export const setUserLanguage =
  (language: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetLanguageData, language });
    } catch (error) {
      dispatch({ type: Actions.SetLanguageDataFail, error });
    }
  };

export const setParticipantId =
  (id: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetParticipantId, id });
    } catch (error) {
      dispatch({ type: Actions.SetParticipantIdFail, error });
    }
  };
